import React, { useEffect, useRef, useState } from "react";
import styles from "./assign.module.scss";

export interface AddOptionDropDownOption {
  key: string;
  value: string;
  visible?: 0 | 1;
}

interface AddOptionDropDownProps {
  addNewQuestionOption: (value: AddOptionDropDownOption, type: string, parentIndex: number) => void;
  type: string;
  parentIndex: number;
  addOption?: AddOptionDropDownOption[];
  clsName?: string;
}

export const AddOptionDropDown: React.FC<AddOptionDropDownProps> = ({ addNewQuestionOption, type, parentIndex, addOption, clsName }) => {
  const dropRef = useRef<HTMLDivElement | HTMLButtonElement>(null);
  const [addMoreOption, setAddMoreOption] = useState(false);

  const addNewQuestionOptionSelect = (value: AddOptionDropDownOption, type: string, parentIndex: number) => {
    setAddMoreOption(false);
    addNewQuestionOption(value, type, parentIndex);
  };

  const showAddOption = () => {
    setAddMoreOption(true);
  };

  useEffect(() => {
    const handleClickOut = (e: MouseEvent) => {
      if (dropRef !== null && dropRef.current && !dropRef.current.contains(e.target as Node)) {
        setAddMoreOption(false);
      }
    };
    document.addEventListener("mousedown", handleClickOut);
    return () => document.removeEventListener("mousedown", handleClickOut);
  });

  return (
    <div className={"col-4 p-0"}>
      <button type="button" className={`btn ml-5 w-auto ${styles.btn_custom_branch}`} onClick={() => showAddOption()} ref={dropRef as React.RefObject<HTMLButtonElement>}>
        Add New
      </button>
      {addMoreOption && (
        <div className={`dropdown-menu show ${styles.dropdown_align_add}`} ref={dropRef as React.RefObject<HTMLDivElement>}>
          {addOption?.map(
            (value, index) =>
              value.visible !== 0 && (
                <p className={`${styles.dropdown_heading_add} ${clsName} addAnsw`} key={index} onClick={() => addNewQuestionOptionSelect(value, type, parentIndex)}>
                  <span>{value.value}</span>
                </p>
              )
          )}
        </div>
      )}
    </div>
  );
};
